/**
 * @method formatRouter 格式化路由表
 * @param {Array} treeList 后台请求返回的权限树
 * @param {Array} routerList 前端组合路由表
 * @param {Array} constantRoutes 前端静态路由表
 * @param {Array} asyncRoutes  前端动态路由表
 * @param {string} key 后台权限树的key，本次是id
 * @returns {Array} filterRouter
 */
export function formatRouter(
  treeList,
  routerList,
  constantRoutes,
  asyncRoutes,
  key
) {
  let filterRouter = [];
  let firstTreeKey = [], // 菜单一级路由模块
    secondTreeKey = [], // 页面二级路由
    thirdTreeKey = [], // 按钮级别权限列表
    commonList = []; // 全体id

  if (!treeList) {
    return [];
  }
  firstTreeKey = treeList.map((item) => {
    if (item.checked) {
      return item[key];
    }
  });
  // 2维数组
  secondTreeKey = treeList.map((item) => {
    if (item.childTrees && item.checked) {
      return item.childTrees.map((sitem) => {
        return sitem[key];
      });
    }
  });

  // 3维数组
  thirdTreeKey = treeList.map((item) => {
    if (item.childTrees && item.checked) {
      return item.childTrees.map((sitem) => {
        if (sitem.childTrees && sitem.checked) {
          return sitem.childTrees.map((ssitem) => {
            return ssitem[key];
          });
        }
      });
    }
  });
  // 多维数组降维成一维数组
  secondTreeKey = secondTreeKey.flat(2);
  thirdTreeKey = thirdTreeKey.flat(3);

  // 全部选中的权限id
  commonList = [...firstTreeKey, ...secondTreeKey, ...thirdTreeKey, 1];

  localStorage.setItem("commonList", JSON.stringify(commonList));
  localStorage.setItem("domAuthList", JSON.stringify(commonList));

  console.log(commonList);

  // 重新过来路由表
  filterRouter = routerList;

  // 页面权限路由设置  、根据isAllow判断
  filterRouter.forEach((item, index) => {
    if (!commonList.includes(item.menuId)) {
      item.isAllow = false;
    } else {
      item.children.forEach((sitem) => {
        if (!commonList.includes(sitem.menuId)) {
          sitem.isAllow = false;
        } else {
          sitem.isAllow = true;
        }
      });

      let array = item.children.filter((sitem) => sitem.isAllow === true);
      if (array.length > 0) {
        item.isAllow = true;
      } else {
        item.isAllow = false;
      }
    }
  });
  filterRouter = filterRouter.filter((item) => item.isAllow === true);
  filterRouter.forEach((item) => {
    item.children = item.children.filter((sitem) => {
      return sitem.isAllow === true;
    });
  });

  let allowUrlList = [];
  allowUrlList = formatAllowUlr(
    filterRouter,
    treeList,
    constantRoutes,
    asyncRoutes
  );
  localStorage.setItem("filterRouter", JSON.stringify(filterRouter));
  localStorage.setItem("allowUrlList", JSON.stringify(allowUrlList));

  return filterRouter;
}

/**
 * @method formatAllowUlr  过滤允许通过输入url来获取组件的权限
 * @param {Array} filterRouter 已处理过的前端路由表
 * @param {Array} treeList  后台接口返回的权限树
 * @param {Array} constantRoutes  前端静态路由表
 * @param {Array} asyncRoutes 前端动态路由表
 * @returns {Array} urlList
 *
 */
export function formatAllowUlr(
  filterRouter,
  treeList,
  constantRoutes,
  asyncRoutes
) {
  if (!treeList) {
    return [];
  }

  let commUrl = [];
  let firstUrl = filterRouter.map((item) => {
    return item.path;
  });

  let secondUrl = filterRouter.map((item) => {
    if (item.children.length > 0) {
      return item.children.map((sitem) => {
        return item.path + "/" + sitem.path;
      });
    }
  });

  let onlyUrl = constantRoutes.map((item) => {
    return item.path;
  });

  secondUrl.forEach((item) => {
    commUrl = [...commUrl, ...item];
  });

  commUrl = [...commUrl, ...firstUrl, ...onlyUrl];

  localStorage.setItem("targetUrlIdList", JSON.stringify("commUrl"));
  return commUrl;
}
